var map = {
	"./alessandro-erbetta-mpWPcRT9D1E-unsplash-1920.jpg": 61353,
	"./daniele-levis-pelusi-jTknOGI18us-unsplash-1920.jpg": 8973,
	"./joey-kyber-45FJgZMXCK8-unsplash-1920.jpg": 5194,
	"./simon-zhu-4hluhoRJokI-unsplash-1920.jpg": 90727
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35025;